import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import { useCallback } from "react";
import { useDialogBetter } from "../../../hooks/useDialogBetter";
import { ManageEmailFootersDialog } from "./ManageEmailFootersDialog";

export const ManageEmailFootersButton = (props) => {
    const { sellerId } = props;
    const { openDialog } = useDialogBetter();

    const handleClick = useCallback(
        () =>
            openDialog({
                Component: ManageEmailFootersDialog,
                componentProps: { sellerId },
            }),
        [openDialog, sellerId],
    );

    return (
        <IconButton onClick={handleClick}>
            <EditIcon />
        </IconButton>
    );
};
